import {
  ItemListContainer,
  ItemWrapper,
  ItemInfoWrapper,
  ItemTitleWrapper,
  ColumnWrapper,
  ItemLeftWrapper,
  ItemActionsWrapper,
} from "./itemList.styled";
import { Typography, Icon, Button } from "@ann/web-components";

const SMSItem = ({ info, onOpen }) => {
  const handleOpen = () => {
    onOpen?.(info);
  };

  return (
    <ItemListContainer>
      <ItemWrapper>
        <ItemLeftWrapper>
          <ItemTitleWrapper>
            <Icon name="sms" size="small" />
            <Typography category="subtitle" weight="bold" size="medium">
              {info.type}
            </Typography>
          </ItemTitleWrapper>
          <ItemInfoWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                From
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.From}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                To
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.To}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                Replies
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.Replies}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                Status
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.Status}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                Body
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.Body}
              </Typography>
            </ColumnWrapper>
            <ColumnWrapper>
              <Typography category="subtitle" weight="bold" size="small">
                Timestamp
              </Typography>
              <Typography
                category="body"
                weight="regular"
                size="small"
                color="body"
              >
                {info.timestamp}
              </Typography>
            </ColumnWrapper>
          </ItemInfoWrapper>
        </ItemLeftWrapper>
        <ItemActionsWrapper>
          <Button
            size="small"
            type="secondary"
            icon="chevronRight"
            pill
            onClick={handleOpen}
          />
        </ItemActionsWrapper>
      </ItemWrapper>
    </ItemListContainer>
  );
};

export default SMSItem;